import { logError } from '@zg-rentals/log-error';

const DATAGRAIL_ERROR_TYPE_PREFIX = 'DataGrailError';
const COOKIE_PREFERENCE_CLASS_NAME = 'cookie-preference';

function showConsentBanner(_event?: MouseEvent) {
  try {
    if (
      'DG_BANNER_API' in window &&
      typeof window.DG_BANNER_API === 'object' &&
      window.DG_BANNER_API !== null &&
      'showLayer' in window.DG_BANNER_API &&
      typeof window.DG_BANNER_API.showLayer === 'function'
    ) {
      window.DG_BANNER_API.showLayer('categories-layer');
    }
  } catch (error) {
    logError({
      error,
      errorType: `${DATAGRAIL_ERROR_TYPE_PREFIX}__ShowConsentBanner`,
      context: 'Failed to open Datagrail consent banner',
    });
  }
}

const waitForFooterElements = (callback: (elements: HTMLCollectionOf<HTMLElement>) => void): void => {
  let attempts = 0;
  // this is only to add the callback after the footer elements
  const maxAttempts = 10; // 10 seconds max (10 * 1 second)

  const poll = () => {
    // even though every element can have an `onclick` the base `Element` type does not support
    // that type, here we know the footer button/links will be HTML elements
    const elements = document.getElementsByClassName(COOKIE_PREFERENCE_CLASS_NAME) as HTMLCollectionOf<HTMLElement>;

    if (elements.length > 0) {
      callback(elements);
      return;
    }
    if (attempts >= maxAttempts) {
      logError({
        error: new Error('Failed to find footer elements to attach click handler'),
        errorType: `${DATAGRAIL_ERROR_TYPE_PREFIX}__WaitForFooterElements`,
      });
      return;
    }

    attempts++;
    setTimeout(poll, 1_000);
  };

  poll();
};

export function attachDatagrailClickHandler() {
  try {
    waitForFooterElements((elements) => {
      for (const el of elements) {
        // prefer `onclick` over `addEventListener` so there cannot be multiple callbacks executing
        el.onclick = showConsentBanner;
      }
    });
  } catch (error) {
    logError({
      error,
      errorType: `${DATAGRAIL_ERROR_TYPE_PREFIX}__AttachDatagrailClickHandler`,
    });
  }
}
